<template lang="pug">
  .container-payment-list-mobile
    c-header
      template(slot="left")
        h3 收款账户管理
      template(slot="right")
        el-button(type="primary", @click="showCreate") 添加收款账户
      //- c-box.container-filters
        el-form(:model="filters",label-position="right",label-width="100px")
          el-row(:gutter="10")
            el-col(:span="8")
              el-form-item(label="收款账户")
                el-input(v-model="filters.keyword")
            el-col(:span="8")
              el-form-item(label="账户 ID")
                el-input(v-model="filters.account_id")
                  el-option(:value="null", label="所有")
            el-col(:span="8")
              el-form-item(label="")
                el-button(@click="setFilter",type="primary") 搜索
                el-button(@click="clearFilter", v-show="hasFilter") 清除
    c-box.paymentCard-container
      .payment-item(v-for="p in list", :key="p.account_id", @click="showDetail(p.account_id)")
        .display-block
          .black {{ p.desc }}
          .small.grey {{ p.account_id }}
        fa-icon(icon="angle-right")
    .container-pagination
      el-pagination(layout="prev, pager, next, total", :current-page="page", :total="total", :page-size="size", @current-change="getList")

    el-dialog(title="添加收款账户", :visible.sync="createAccount.show", width="100%")
      .data-block
        data-row(label="收款账户名称", required)
          el-input(v-model="createAccount.desc")
      .dialog-footer(slot="footer")
        el-button(type="primary", @click="saveCreate()") 保存
        el-button(@click="hideCreate()") 取消
</template>

<script>
export default {
  data() {
    return {
      page: 1,
      size: 20,
      status: 0,
      list: [],
      total: 0,

      listLoading: false,

      filters: {
        account_id: null,
        keyword: null
      },
      hasFilter: false,

      createAccount: {
        show: false,
        desc: null
      },

      account_limit: 0
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    }
  },
  methods: {
    showCreate() {
      if (this.list.length < this.account_limit) {
        this.createAccount = {
          show: true,
          desc: null
        };
      } else {
        this.$message({
          type: "warning",
          message: `您只能最多创建 ${this.account_limit} 个收款账户。`
        });
      }
    },
    hideCreate() {
      this.createAccount = {
        show: false,
        desc: null
      };
    },
    saveCreate() {
      if (!this.createAccount.desc) {
        this.$message({
          type: "warning",
          message: `请输入账户名称。`
        });
      }
      this.$store
        .dispatch("CREATE_ACCOUNT", this.createAccount.desc)
        .then(({ account_id }) => {
          this.hideCreate();
          this.getList(1);

          this.$message({
            type: "success",
            message: "收款账户添加成功。稍后将进入账户详情页面……"
          });

          const t = setTimeout(() => {
            clearTimeout(t);
            this.showDetail(account_id);
          }, 3 * 1000);
        })
        .catch(({ code, msg }) => {
          if (code == 45101) {
            this.$message({
              type: "error",
              message: `添加失败，请现在结算账户管理中，添加或绑定富力钱包`
            });
          } else {
            this.$message({
              type: "error",
              message: `收款账户添加失败。${code}：${msg}`
            });
          }
        });
    },

    showDetail(account_id) {
      this.$router.push(`/payment-mobile/${account_id}`);
    },

    getAccountLimit() {
      const { uname } = this.userInfo;
      return this.$store
        .dispatch("GET_MCH_DETAIL", uname)
        .then(({ account_limit }) => {
          this.account_limit = account_limit;
          return account_limit;
        })
        .catch(({ code, msg }) => {
          this.$alert(`收款账户数量上限获取失败。${code}：${msg}`, {
            type: "error"
          });
        });
    },

    setFilter() {
      if (this.filters.account_id || this.filters.keyword) {
        this.hasFilter = true;
      } else {
        this.hasFilter = false;
      }

      this.refresh();
    },
    clearFilter() {
      this.filters = {
        account_id: null,
        keyword: null
      };
      this.hasFilter = false;
      this.refresh();
    },
    refresh() {
      this.getList(this.page);
    },
    changeListSize(size = 20) {
      this.size = size;
      this.getList(1);
    },
    getList(page = 1) {
      if (!this.listLoading) {
        this.page = page;
        this.listLoading = true;
      } else {
        return;
      }

      const _filters = Object.assign({}, this.filters);
      this.$store
        .dispatch(
          "GET_ACCOUNT_LIST",
          Object.assign(
            {
              offset: this.size * (this.page - 1),
              limit: this.size,
              stat: true
            },
            _filters
          )
        )
        .then(data => {
          this.list = data.list;
          this.total = data.total;
        })
        .catch(({ msg }) => {
          this.$alert(`${msg}`, {
            type: "error"
          });
        })
        .finally(() => {
          this.listLoading = false;
        });
    }
  },
  mounted() {
    this.getAccountLimit();
    this.getList(1);
  }
};
</script>

<style lang="less">
@import (reference) "../../assets/general";

.container-payment-list-mobile {
  .paymentCard-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;

    padding: 0;
  }

  .payment-item {
    .flex(center, space-between);
    .max-width;
    height: 40px;
    padding: 10px 10px 10px 20px;
    background: @white;

    border-top: 1px solid @hr-grey;

    &:last-child {
      border-bottom: 1px solid @hr-grey;
    }
  }
}
</style>
